
// UX Management: DSR posts are updating
export const SET_ADDED_PROCESSING_DSR_POST = 'set_added_processing_dsr_post';
export const SET_REMOVED_PROCESSING_DSR_POST = 'set_removed_processing_dsr_post';

export const SET_ADD_IN_PROCESS_NEW_DSR_POST = 'set_add_in_process_new_dsr_post';
export const SET_REMOVE_IN_PROCESS_NEW_DSR_POST = 'set_remove_in_process_new_dsr_post';